import React from 'react';
import { Stack } from '@mui/material';
import { Heading, Text } from '@web-for-marketing/react-ui';
import { useAdminRoute } from '@hooks/useAdminRoute';
import { SectionContainer } from '@components/SectionComponents/SectionContainer';

type PrivateRouteProps = {
    permission: string;
    minimumAccessLevel?: number;
    children: React.ReactElement;
};

export function PrivateRoute({
    permission,
    minimumAccessLevel = 100,
    children,
}: PrivateRouteProps): React.ReactElement | null {
    const hasRouteAccess = useAdminRoute(permission, minimumAccessLevel);

    return hasRouteAccess ? (
        children
    ) : (
        <SectionContainer>
            <Stack alignItems='center' justifyContent='center' direction='column' gap={2}>
                <Heading variant='h1'>Oh no!</Heading>
                <Text>You do not have permission to access this page.</Text>
            </Stack>
        </SectionContainer>
    );
}
